import $ from 'jquery';

export default () => {

    if ($('.ce_form p.error').length > 0) {
        const $errorform = $('.ce_form p.error').closest('.ce_form');
        $('html, body').animate({scrollTop: $errorform.offset().top});
    }

};
